import * as ActionTypes from "constants/ActionTypes";

/**
 * Get stateKey from props. If it can't be found, throw an error.
 *
 * @param {Record<string, unknown>} props
 * @returns {string}
 */
function getStateKeyFromProps(props) {
  const stateKey =
    typeof props.stateKey === "string"
      ? props.stateKey
      : typeof props.chapterId === "number"
      ? `chapter-${props.chapterId}`
      : null;

  if (!stateKey) {
    throw new Error("Could not figure out state key");
  }

  return stateKey;
}

export const destroyPlaybackState = (stateKey) => ({
  stateKey,
  type: ActionTypes.DESTROY_PLAYBACK_STATE,
});

// DO NOT CALL THIS FROM ANYWHERE EXCEPT FOR THE ALT FLUX IMPLEMENTATION.

export const setPlaybackState = (stateKey, value) => ({
  stateKey,
  type: ActionTypes.SET_PLAYBACK_STATE_FROM_ALT_DO_NOT_USE_THIS,
  value,
});

export function changePlaybackState(ownProps, value) {
  return {
    stateKey: getStateKeyFromProps(ownProps),
    type: ActionTypes.CHANGE_PLAYBACK_STATE,
    value,
  };
}

export function seekForward(ownProps) {
  return {
    stateKey: getStateKeyFromProps(ownProps),
    type: ActionTypes.SEEK_FORWARD,
  };
}

export function seekBack(ownProps) {
  return {
    stateKey: getStateKeyFromProps(ownProps),
    type: ActionTypes.SEEK_BACK,
  };
}
